'use client';

import React from 'react';
import { ShieldAlert, Download } from 'lucide-react';

interface AuditHeaderProps {
  totalCount: number;
  onExport: () => void;
}

export default function AuditHeader({ totalCount, onExport }: AuditHeaderProps) {
  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-border bg-card">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center">
          <ShieldAlert size={18} className="text-primary" />
        </div>
        <div>
          <h1 className="text-lg font-semibold text-foreground leading-tight">Audit Log</h1>
          <p className="text-xs text-muted-foreground">
            {totalCount > 0 ? `${totalCount} event${totalCount !== 1 ? 's' : ''} recorded` : 'Healthcare compliance & dispute resolution'}
          </p>
        </div>
      </div>
      <button
        onClick={onExport}
        className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-muted-foreground border border-border rounded-lg hover:bg-muted hover:text-foreground transition-colors"
      >
        <Download size={15} />
        Export CSV
      </button>
    </div>
  );
}
